import React, {useEffect, useState} from "react";
import {PAYMENT_TYPE} from "../../../constants";
import {convertPriceUnitAmountToReadable} from "../../../helpers/helpers";

const PlanSelectUpdateContainer = ({isUpgrade, levels, selectedLevelValue, setSelectedLevelValue,
                                       selectedPlan, doNotRenew, paymentType, testid = 'planSelectUpdateContainerDiv'}) => {
    const [selectableLevels, setSelectableLevels] = useState([]);

    const maxCountKey = paymentType === PAYMENT_TYPE.VRI ? 'maxInspectorCount' : 'maxScanCount';
    const selectedShowMonths = selectedPlan?.months === 1;
    const selectedMaxCount = (paymentType === PAYMENT_TYPE.VRI ? selectedPlan[maxCountKey] : selectedPlan[maxCountKey]) || 0;

    useEffect(() => {
        if (!levels)
            return;

        const priceFormatLabel = selectedShowMonths ? i18n.payments.month : i18n.payments.year;

        const newSelectableLevels = levels.filter(level => {
            const maxCount = level[maxCountKey];
            return isUpgrade ? maxCount > selectedMaxCount : maxCount < selectedMaxCount;
        }).map((level, idx) => {
            const paymentFormatData = selectedShowMonths ? level.monthly : level.yearly;
            const { value, priceAmount } = paymentFormatData;
            const amount = convertPriceUnitAmountToReadable(priceAmount);
            const onClick = () => setSelectedLevelValue(value);
            const selected = selectedLevelValue === value;
            return { level, selected, amount, priceFormatLabel, value, onClick };
        });

        setSelectableLevels(newSelectableLevels);
    }, [levels, selectedLevelValue]);

    return (
        <div className={'row'}>
            <div className={'col-12 plan-select-column'} data-testid={testid}>
                {
                    selectableLevels.map(({level, selected, amount, priceFormatLabel, value, onClick}) => (
                        <div className={"col-4 plan-select-row flexColumn"}
                             data-testid={'selectableLevelDiv'}
                             data-value={value}
                             data-selected={selected}
                             data-amount={amount}
                             key={`level-${value}`}>
                            <div className={`vri-plan-card flexColumn ${selected ? "selected" : ""}`} onClick={onClick}>
                                <div className={"plan-sub-title"}>{level.label}</div>
                                <div className={"plan-sub-details"}>{i18n.payments.pricing}</div>
                                <div className={"plan-sub-title"}>{`$${amount} / ${priceFormatLabel}`}</div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default PlanSelectUpdateContainer;